import ContractorPage from "./ContractorPage";

export default ContractorPage;
